export default __webpack_public_path__ + "static/media/6d.e65175b8.png";